require('./hireCardImageSelector.scss');

// @ vendors
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');
const classnames = require('classnames');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ actions
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilities
const {
    PROC_SELECT_CARD_DESIGN,
    recordLink,
} = require('utilities/tagging');

class HireCardImageSelector extends React.PureComponent {

    componentDidMount(){
        const {
            cardImageIds,
            immHireCardImageSelector,
            extraImage,
            getHireCardImages,
        } = this.props;

        if (!immHireCardImageSelector.get('fetchSuccess')) {
            getHireCardImages(cardImageIds, extraImage);
        }
    }
    handleOnClick(id) {
        const {
            hireCardImagesUpdateSelectedId,
            onChange,
            tealiumEventCategory,
        } = this.props;

        if (!!tealiumEventCategory) {
            recordLink(tealiumEventCategory, PROC_SELECT_CARD_DESIGN, id);
        }

        if (!!onChange) {
            onChange(id);
        }
        hireCardImagesUpdateSelectedId(id);
    }

    buildCardGrid() {
        const {
            immHireCardImageSelector,
            extraImage
        } = this.props;
        const totalImages = immHireCardImageSelector.get('imagesByOrder').size;
        let firstOffsetRow = false;
        let secondOffsetRow = false;
        let offsetValue;

        if(totalImages === 2) {
            offsetValue = 2;
            firstOffsetRow = true;

        } else if(totalImages === 4) {
            offsetValue = 2;
            firstOffsetRow = true;
            secondOffsetRow = true;

        } else if(totalImages === 5) {
            secondOffsetRow = true;
            offsetValue = 2;
        }

        const primaryGridClassName = classnames(
            'hire-card-image-selector__cell', 'col-sm-4', {
                'hire-card-image-selector__cell--extra': extraImage
            }
        );

        const iconClassName = classnames(
            'icon-exito',
            'hire-card-image-selector__icon-selected',
            {
                'hire-card-image-selector__icon-selected--extra': extraImage
            }
        );

        return immHireCardImageSelector.get('imagesByOrder').map((imageId, index) => {
            const immImage = immHireCardImageSelector.getIn(['imagesById', imageId]);
            const id = immImage.get('id');
            const url = immImage.get('url');
            const isSelected = id === immHireCardImageSelector.get('selectedImageId');
            const imageClassName = classnames(
                'hire-card-image-selector__card-image', {
                    [`hire-card-image-selector__card-image--extra`] : extraImage,
                    'hire-card-image-selector__card-image--selected': isSelected
                }
            );

            let selectedIcon;
            if (isSelected) {
                selectedIcon = <i className={iconClassName} />;
            }

            let extraImageElement;
            if (extraImage) {
                const extraImageSrc = immHireCardImageSelector.getIn(['extraImageById', extraImage, 'url']);
                const extraImageClassName = `${imageClassName} hire-card-image-selector__extra-image`;

                extraImageElement = (
                    <div className="hire-card-image-selector__extra-image-container">
                        <img
                            className={extraImageClassName}
                            src={extraImageSrc}
                        />
                    </div>
                );
            }

            let offset = 0;

            if(index === 0) {
                if(firstOffsetRow) {
                    offset = offsetValue;
                }
            } else if (index === 2) {
                if(firstOffsetRow && secondOffsetRow) {
                    offset = offsetValue;
                }
            } else if (index === 3) {
                if(!firstOffsetRow && secondOffsetRow) {
                    offset = offsetValue;
                }
            }
            const gridClassName = classnames(primaryGridClassName, [`col-sm-offset-${offset}`]);

            return (
                <div className={gridClassName} key={index} >
                    <img
                        className={imageClassName}
                        onClick={() => this.handleOnClick(id)}
                        src={url}
                    />
                    {selectedIcon}
                    {extraImageElement}
                </div>
            );
        });
    }

    render() {
        const { immHireCardImageSelector, isNerudaCard } = this.props;
        let content;

        if (immHireCardImageSelector.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const {
                customTitle,
                extraClass,
                extraImage,
            } = this.props;
            const cards = this.buildCardGrid();

            let title = 'hireCardImageSelector-title';
            let subtitle;

            if (!!customTitle) {
                title = customTitle;
            } else {
                title = 'hireCardImageSelector-title';

                if (immHireCardImageSelector.get('imagesById').size === 1) {
                    if (isNerudaCard) {
                        title = 'hireCardImageSelector-hireCardImageSelector_titleOneCardNeruda';
                    } else {
                        title = 'hireCardImageSelector-hireCardImageSelector_titleOneCard';
                    }
                }
    
                if (!!extraImage) {
                    title = 'hireCardImageSelector-titleExtra';
                    subtitle = <FormattedText value="hireCardImageSelector-subtitle" className="hire-card-image-selector__subtitle" />;
                }
            }

            content = (
                <article className="hire-card-image-selector">
                    <header className="hire-card-image-selector__header">
                        <h4 className="hire-card-image-selector__title">
                            <FormattedText value={title} />
                        </h4>
                    </header>
                    {subtitle}
                    <section className={`row ${extraClass}`}>
                        {cards}
                    </section>
                </article>
            );
        }

        return content;
    }
}

HireCardImageSelector.propTypes = {
    cardImageIds: PropTypes.array.isRequired,
    customTitle: PropTypes.string,
    extraClass: PropTypes.string,
    extraImage: PropTypes.string,
    getHireCardImages: PropTypes.func.isRequired,
    hireCardImagesUpdateSelectedId: PropTypes.func.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    isNerudaCard: PropTypes.bool,
    onChange: PropTypes.func,
    tealiumEventCategory: PropTypes.string,
};

HireCardImageSelector.defaultProps = {
    extraImage: '',
    images: [],
    isNerudaCard: false,
};

module.exports.constructor = HireCardImageSelector;

module.exports.HireCardImageSelector = connect(null,
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        hireCardImagesUpdateSelectedId: hireCardImageSelectorActions.hireCardImagesUpdateSelectedId,
        reset: hireCardImageSelectorActions.reset
    }
)(HireCardImageSelector);
